@file:OptIn(InternalResourceApi::class)

package tovtalk_kmp_v2.android_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tovtalk_kmp_v2.android_ui.generated.resources/"

@delegate:ResourceContentHash(505_150_176)
public val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-886_818_231)
public val Res.drawable.ic_google_g: DrawableResource by lazy {
      DrawableResource("drawable:ic_google_g", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google_g.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("ic_google_g", Res.drawable.ic_google_g)
}
